import axios from 'axios';
import authService from './authService';

const API_URL = '/api/updates/';

// Add a request interceptor to include the auth token
axios.interceptors.request.use(
  (config) => {
    const user = authService.getCurrentUser();
    if (user && user.accessToken) {
      config.headers.Authorization = 'Bearer ' + user.accessToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

class UpdateService {
  // Public endpoints
  getPublishedUpdates() {
    return axios.get(API_URL + 'public');
  }

  getUpdateById(id) {
    return axios.get(API_URL + `public/${id}`);
  }

  getUpdatesByType(type) {
    return axios.get(API_URL + `public/type/${type}`);
  }

  // Admin endpoints
  getAllUpdates(page = 0, size = 10, sortBy = 'publishDate', sortDir = 'desc') {
    return axios.get(API_URL + `admin?page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}`);
  }

  createUpdate(updateData) {
    return axios.post(API_URL + 'admin', updateData);
  }

  updateUpdate(id, updateData) {
    return axios.put(API_URL + `admin/${id}`, updateData);
  }

  deleteUpdate(id) {
    return axios.delete(API_URL + `admin/${id}`);
  }
}

export default new UpdateService();